import {
  AccessibilityInfo,
  AppState,
  Keyboard,
  type AppStateStatus,
} from 'react-native';

type KeyboardEventName = Parameters<typeof Keyboard.addListener>[0];
type KeyboardListener = Parameters<typeof Keyboard.addListener>[1];

export function subscribeToAppStateChange(listener: (state: AppStateStatus) => void) {
  const subscription = AppState.addEventListener('change', listener);
  return () => subscription.remove();
}

export function subscribeToKeyboardEvent(eventName: KeyboardEventName, listener: KeyboardListener) {
  const subscription = Keyboard.addListener(eventName, listener);
  return () => subscription.remove();
}

export function subscribeToReduceMotionChange(listener: (enabled: boolean) => void) {
  const subscription = AccessibilityInfo.addEventListener('reduceMotionChanged', listener);
  return () => subscription.remove();
}

export function scheduleTimeout(listener: () => void, delay: number) {
  const timeout = setTimeout(listener, delay);
  return () => clearTimeout(timeout);
}
